module.exports = __webpack_public_path__ + "img/coupon.b2d53a55.svg";